var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g4, _path13, _g5, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g6, _g7, _path36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#41479b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.862 220.691H8.828A8.829 8.829 0 0 1 0 211.863V97.104a8.829 8.829 0 0 1 8.828-8.828h203.034a8.829 8.829 0 0 1 8.828 8.828v114.759a8.829 8.829 0 0 1-8.828 8.828zM503.172 423.725H300.138a8.829 8.829 0 0 1-8.828-8.828V300.139a8.829 8.829 0 0 1 8.828-8.828h203.034a8.829 8.829 0 0 1 8.828 8.828v114.759a8.828 8.828 0 0 1-8.828 8.827z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172 220.691H300.138a8.829 8.829 0 0 1-8.828-8.828V97.104a8.829 8.829 0 0 1 8.828-8.828h203.034A8.829 8.829 0 0 1 512 97.104v114.759a8.829 8.829 0 0 1-8.828 8.828zM211.862 423.725H8.828A8.829 8.829 0 0 1 0 414.897V300.139a8.829 8.829 0 0 1 8.828-8.828h203.034a8.829 8.829 0 0 1 8.828 8.828v114.759a8.828 8.828 0 0 1-8.828 8.827z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#64b496"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.932 281.172s5.274 1.931 4.586 8.552l2.132-.04s-1.345-7.651-2.457-8.568-4.261.056-4.261.056z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.218 280.15c-2.237 0-6.147-.003-10.259-1.113.917-.954 2.184-2.876 2.184-6.227 0-5.248-3.616-1.9-3.616-1.9s-2.378 2.001-.94 7.35a20.733 20.733 0 0 1-4.119-2.109c.825-1.036 2.471-3.45 3.427-7.278 0 0-6.026-1.191-7.674 3.347a20.724 20.724 0 0 1-2.595-4.317c1.549.019 3.71-1.003 3.71-6.901 0 0-3.935.007-4.986 3.42a33.552 33.552 0 0 1-.961-4.572c1.571.456 5.633.783 5.633-8.032 0 0-4.877.009-6.006 4.329a52.456 52.456 0 0 1-.075-3.425c2.368-1.238 5.636-3.965 5.297-9.56 0 0-2.249.51-4.311 2.239.406-2.121.238-5.226-3.015-7.817 0 0-2.989 5.29 1.377 9.585a8.851 8.851 0 0 0-.984 1.817c-.981-1.494-2.554-2.883-5.088-3.727 0 0-1.166 7.085 5.449 10.049.157 4.138.804 7.794 1.916 10.973-1.895-1.669-3.428-3.967-3.428-3.967 0-7.872-6.453-8.071-6.453-8.071-1.205 8.985 5.439 9.348 5.439 9.348l3.638 3.97c-7.872-1.312-7.872 5.248-7.872 5.248 5.248 1.312 7.872-1.312 7.872-1.312l2.838 1.459c-5.034.147-6.774 5.101-6.774 5.101 6.327 1.055 10.953-.433 12.526-1.057 6.372 4.455 14.226 4.461 17.852 4.461v-1.311h-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.772 280.15c2.237 0 6.147-.003 10.259-1.113-.917-.954-2.184-2.876-2.184-6.227 0-5.248 3.616-1.9 3.616-1.9s2.378 2.001.94 7.35a20.733 20.733 0 0 0 4.119-2.109c-.825-1.036-2.471-3.45-3.427-7.278 0 0 6.026-1.191 7.674 3.347a20.724 20.724 0 0 0 2.595-4.317c-1.549.019-3.71-1.003-3.71-6.901 0 0 3.935.007 4.988 3.42.414-1.427.729-2.956.961-4.572-1.571.456-5.633.783-5.633-8.032 0 0 4.877.009 6.006 4.329.062-1.105.086-2.247.075-3.425-2.368-1.238-5.636-3.965-5.297-9.56 0 0 2.249.51 4.311 2.239-.406-2.121-.238-5.226 3.015-7.817 0 0 2.989 5.29-1.377 9.585.38.534.711 1.142.984 1.817.981-1.494 2.554-2.883 5.088-3.727 0 0 1.166 7.085-5.449 10.049-.157 4.138-.804 7.794-1.916 10.973 1.895-1.669 3.428-3.967 3.428-3.967 0-7.872 6.453-8.071 6.453-8.071 1.205 8.985-5.439 9.348-5.439 9.348l-3.638 3.97c7.872-1.312 7.872 5.248 7.872 5.248-5.248 1.312-7.872-1.312-7.872-1.312l-2.838 1.459c5.034.147 6.774 5.101 6.774 5.101-6.327 1.055-10.953-.433-12.526-1.057-6.372 4.455-14.226 4.461-17.852 4.461v-1.311z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.863 222.956a44.99 44.99 0 0 0-11.958 11.167l4.224 3.115a39.747 39.747 0 0 1 10.551-9.856l-2.817-4.426z",
    fill: "#41479b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.014 257.067h18.367v10.496a5.247 5.247 0 0 1-5.248 5.248h-7.872c-2.156 0-4.052 1.054-5.248 2.66l.001-18.404z",
    fill: "#ff6b71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5f64b9",
    d: "M259.95 245.259v-14.432h19.68l-5.248 5.248v14.432H259.95z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M267.82 250.501h6.56v6.56h-6.56z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256.014 257.067h-18.367v10.496a5.247 5.247 0 0 0 5.248 5.248h7.872c2.156 0 4.052 1.054 5.248 2.66l-.001-18.404z",
    fill: "#ff6b71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M252.735 273.127a6.586 6.586 0 0 1 3.25 2.307h.061a6.59 6.59 0 0 1 3.25-2.307v-10.813h-6.56l-.001 10.813z",
    fill: "#f5f5f5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#5f64b9",
    d: "M252.079 245.259v-14.432h-19.68l5.248 5.248v14.432h14.432z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M237.65 250.501h6.56v6.56h-6.56z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479b",
    d: "M244.207 237.387v3.936l3.936 2.624v-2.624z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M248.143 241.323v3.936l5.248 2.624v-1.312z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479b",
    d: "M267.822 237.387v3.936l-3.936 2.624v-2.624z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M263.886 241.323v3.936l-5.248 2.624v-1.312z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M263.932 266.25h-15.829c-3.598 0-6.515-2.937-6.515-6.56v-20.291l14.525 9.795 14.333-9.795v20.291c0 3.624-2.916 6.56-6.514 6.56z",
    fill: "#ff4b55"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#41479b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.831 242.635l-5.248-3.936v14.432l5.248 2.624zM265.198 242.635l5.248-3.936v14.432l-5.248 2.624zM248.14 255.761h15.744v6.56H248.14z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M248.143 243.947l7.871 3.936 7.872-3.936v11.808h-15.743z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.919 245.187v13.192a1.97 1.97 0 0 1-1.967 1.967h-7.872a1.97 1.97 0 0 1-1.967-1.967v-13.138l-3.936-2.636v15.774a5.91 5.91 0 0 0 5.903 5.903h7.872a5.91 5.91 0 0 0 5.903-5.903v-15.863l-3.936 2.671z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.293 254.351c-2.21.199-4.697.422-7.278 1.32-2.58-.898-5.068-1.121-7.278-1.32-3.698-.332-5.892-.655-7.148-2.886v3.787c1.929 1.254 4.372 1.484 6.913 1.713 2.281.205 4.639.416 7.049 1.329l.465.175.465-.175c2.409-.913 4.767-1.123 7.049-1.329 2.543-.228 4.99-.455 6.919-1.711v-3.798c-1.257 2.24-3.453 2.563-7.156 2.895z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M258.638 241.979h-1.967v-1.968h-1.312v1.968h-1.968v1.312h1.968v5.904h1.312v-5.904h1.967z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M243.081 236.746l.72-.72 11.529 11.53-.72.719z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M241.278 234.221l1.441 2.882 1.441-1.441z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M245.626 234.758l.824-.6 9.6 13.18-.823.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M244.227 231.984l.977 3.071 1.647-1.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M240.928 239.268l.582-.835 13.368 9.334-.583.835z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M238.71 237.109l1.923 2.585 1.167-1.67z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M257.416 248.266l-.72-.72 11.529-11.528.72.72z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M270.745 234.221l-1.441 2.882-1.441-1.441z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M256.808 247.926l-.824-.6 9.6-13.18.824.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M267.796 231.984l-.977 3.071-1.646-1.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M257.745 248.616l-.583-.835 13.368-9.334.583.835z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M273.313 237.109l-1.923 2.585-1.167-1.67z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M255.349 272.437s-5.074-5.449-4.089-10.451c.791-4.023 3.192-8.458 5.071-9.537 0 0 2.657-.164 1.991 2.144-.666 2.308-1.478 2.903-1.24 5.178.409 3.938 1.044 8.604-1.733 12.666z",
    fill: "#f5f5f5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M256.888 252.478c-.317-.042-.558-.028-.558-.028-1.879 1.079-4.28 5.514-5.071 9.537-.448 2.275.361 4.638 1.373 6.543-.641-8.248 1.767-11.174 4.256-16.052z",
    fill: "#41479b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M257.08 259.773c-.237-2.275.574-2.87 1.24-5.178.467-1.615-.693-2.019-1.432-2.116 0 0-1.694 3.892-1.803 6.503-.096 2.297.492 11.644.264 13.458 2.777-4.065 2.142-8.731 1.731-12.667z",
    fill: "#ff4b55"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M253.639 254.424a4.608 4.608 0 0 1 3.999-1.242l-2.07-6.664a4.616 4.616 0 0 0-3.999 1.242c.689 2.222 1.38 4.443 2.07 6.664z",
    fill: "#f5f0f0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M257.638 253.182a4.608 4.608 0 0 1 3.999-1.242l-2.07-6.664a4.616 4.616 0 0 0-3.999 1.242l2.07 6.664z",
    fill: "#f5f5f5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M250.022 224.355a39.786 39.786 0 0 0-20.37 5.07l-2.567-4.577a45.017 45.017 0 0 1 23.058-5.74c-.041 1.749-.082 3.498-.121 5.247z",
    fill: "#5f64b9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M278.167 222.956a44.99 44.99 0 0 1 11.958 11.167l-4.224 3.115a39.747 39.747 0 0 0-10.551-9.856l2.817-4.426z",
    fill: "#41479b"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M262.008 224.355a39.786 39.786 0 0 1 20.37 5.07l2.567-4.577a45.017 45.017 0 0 0-23.058-5.74c.041 1.749.082 3.498.121 5.247z",
    fill: "#5f64b9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M266.51 222.956a39.767 39.767 0 0 0-20.991 0l-1.385-5.062a45.037 45.037 0 0 1 23.761 0l-1.385 5.062z",
    fill: "#41479b"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff6b71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.432 281.758a95.255 95.255 0 0 0-16.529 5.985l2.237 4.747a89.835 89.835 0 0 1 15.96-5.742l-1.668-4.99zM273.598 281.758a95.255 95.255 0 0 1 16.529 5.985l-2.237 4.747a89.835 89.835 0 0 0-15.96-5.742l1.668-4.99z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.119 285.816a89.912 89.912 0 0 0-41.983 0l-1.225-5.102a95.168 95.168 0 0 1 44.433 0c-.407 1.7-.816 3.402-1.225 5.102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.014 287.242l-3.618.905a1.312 1.312 0 0 1-1.63-1.272v-1.887c0-.853.802-1.48 1.63-1.272l3.618.905v2.621zM256.014 284.618l3.618-.905a1.312 1.312 0 0 1 1.63 1.272v1.887c0 .853-.802 1.48-1.63 1.272l-3.618-.905v-2.621z"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M256.296 287.242h-.563a1.03 1.03 0 0 1-1.031-1.031v-.563a1.03 1.03 0 0 1 1.031-1.031h.563a1.03 1.03 0 0 1 1.031 1.031v.563a1.032 1.032 0 0 1-1.031 1.031z",
    fill: "#ff6b71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/do.0b9b013f28ec3698c40a0260fcd91c81.svg";
export { ForwardRef as ReactComponent };